import { ContainerSpec } from '@freight-cbm/shared-types';

export const CONTAINER_SPECS: ContainerSpec[] = [
  {
    type: '20ft Standard',
    internalLength: 5.898,
    internalWidth: 2.352,
    internalHeight: 2.393,
    maxPayloadKg: 21700,
    volumeCBM: 33.2,
  },
  {
    type: '40ft Standard',
    internalLength: 12.032,
    internalWidth: 2.352,
    internalHeight: 2.393,
    maxPayloadKg: 26510,
    volumeCBM: 67.7,
  },
  {
    type: '40ft High Cube',
    internalLength: 12.032,
    internalWidth: 2.352,
    internalHeight: 2.698,
    maxPayloadKg: 26330,
    volumeCBM: 76.3,
  },
];
